import React, { useState, useEffect } from 'react';
import './LoginPage.scss';
import { Helmet } from 'react-helmet-async';
import LoginForm from './components/Loginform/LoginForm';
import ForgotPasswordForm from './components/ForgotPasswordForm/ForgotPasswordForm';
import { endTitlePage } from '../../../services/config';

const LoginPage = () => {
    const [showForgotPassword, setShowForgotPassword] = useState(false);

    const headInfos = {
        title: 'Connexion' + endTitlePage,
        description: 'Soutien émotionnel & aide à la parentalité consciente - Connectes-toi à ton espace'
    }
    
    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    return (
        <div className="login-page">
            <Helmet>
                <title>{headInfos.title}</title>
                <meta name="description" content={headInfos.description} />
            </Helmet>
            <div className="logo_container">
                <picture>
                    <source srcSet={'/assets/logo_transparent.webp'} type="image/webp" />
                    <img src={'/assets/logo_transparent.png'} alt="Logo Grandir et s'élever ensembl" loading="eager" fetchpriority="high" />
                </picture>
            </div>
            {showForgotPassword ? (
                <ForgotPasswordForm onBackToLogin={() => setShowForgotPassword(false)} />
            ) : (
                <LoginForm onForgotPassword={() => setShowForgotPassword(true)} />
            )}
        </div>
    );
};

export default LoginPage;